var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.208,
    height: 42.311,
    viewBox: "0 0 40.208 42.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-2.841 0.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_015---Diet-Plan",
    "data-name": "015---Diet-Plan",
    transform: "translate(3 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M40.175,1h-23.1A5.231,5.231,0,0,0,12.7,3.226a.7.7,0,1,0,1.17.77,3.822,3.822,0,0,1,3.2-1.6H36.484a5.583,5.583,0,0,0-1.908,4.2V36.7a.7.7,0,0,1-.7.7h-5.6a.7.7,0,1,0,0,1.4h5.6a2.1,2.1,0,0,0,2.1-2.1V7.3h9.1a.7.7,0,0,0,.7-.7,5.606,5.606,0,0,0-5.6-5.6ZM36.033,5.9a4.2,4.2,0,0,1,8.284,0Z",
    transform: "translate(-5.876 -0.999)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M1.179,17.322a4.9,4.9,0,0,0-1.12,3.951L3.29,41.626a2.344,2.344,0,0,0,4.63,0l.025-.156A6.172,6.172,0,0,0,12.262,43.6a4.2,4.2,0,0,0,1.05-.132A4.139,4.139,0,0,0,14,43.225a4.174,4.174,0,0,0,.688.243c3.143.815,6.72-2.19,7.969-6.693a9.832,9.832,0,0,0-.573-7.361,4.749,4.749,0,0,0-2.533-2.2c.588-.412,1.158-.867,1.642-1.279a1.133,1.133,0,0,0-.51-1.975,12.454,12.454,0,0,0-4.6-.28,4.821,4.821,0,0,0-2.465,1.4,5.382,5.382,0,0,0-.661-.76.7.7,0,1,0-.963,1.017,4.671,4.671,0,0,1,1.338,2.82,2.266,2.266,0,0,1-.605-.274,5.46,5.46,0,0,0-2.488-.9l.905-5.722A4.866,4.866,0,0,0,9.03,16.443l1.9-3.041a1.375,1.375,0,0,0-.026-1.535,1.4,1.4,0,0,0-1.431-.583l-.73.151,1.316-3.948a1.4,1.4,0,0,0-1.671-1.8l-.9.227L6.946,4.027a1.4,1.4,0,0,0-2.691,0l-.54,1.89-.91-.232A1.4,1.4,0,0,0,1.142,7.488l1.314,3.944-.731-.148A1.4,1.4,0,0,0,.3,11.868,1.374,1.374,0,0,0,.267,13.4l1.9,3.045a4.875,4.875,0,0,0-.99.878ZM14.4,26.611c-.1-.4.654-1.23,2.016-1.568a3.934,3.934,0,0,1,.91-.086,14.992,14.992,0,0,1,2.53.272,9.407,9.407,0,0,1-2.94,1.825,3.755,3.755,0,0,1-1.844.029c-.372-.106-.622-.28-.668-.472Zm-1,3v.862a.7.7,0,1,0,1.4,0v-.91a3.744,3.744,0,0,0,1.225-.5,3.564,3.564,0,0,1,2.833-.6,3.306,3.306,0,0,1,2.006,1.647A8.423,8.423,0,0,1,21.31,36.4c-1.05,3.773-3.866,6.334-6.273,5.712a2.82,2.82,0,0,1-.692-.28.7.7,0,0,0-.688,0,2.835,2.835,0,0,1-.694.28c-1.685.436-3.566-.691-4.9-2.7l0-.006A10.522,10.522,0,0,1,6.7,36.4a8.41,8.41,0,0,1,.437-6.286,3.305,3.305,0,0,1,2.007-1.647,2.891,2.891,0,0,1,.721-.09,3.925,3.925,0,0,1,2.111.69,3.741,3.741,0,0,0,1.436.548Zm-3.648-8.56L8.8,27.108H8.788a4.667,4.667,0,0,0-2.87,2.3,9.832,9.832,0,0,0-.573,7.361,11.746,11.746,0,0,0,1.417,3.191l-.227,1.446a.944.944,0,0,1-1.865,0L1.443,21.053A3.509,3.509,0,0,1,4.916,17H6.288a3.508,3.508,0,0,1,3.474,4.049ZM1.45,12.657l.729.146a1.4,1.4,0,0,0,1.61-1.81L2.465,7.042l.91.232A1.4,1.4,0,0,0,5.061,6.3L5.6,4.4l.539,1.89a1.4,1.4,0,0,0,1.693.98l.9-.228L7.413,10.994A1.4,1.4,0,0,0,9.021,12.8l.724-.147L7.759,15.832A4.913,4.913,0,0,0,6.288,15.6H4.916a4.922,4.922,0,0,0-1.476.23Z",
    transform: "translate(0 -1.603)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M37.222,5H24.778A.742.742,0,0,0,24,5.7a.742.742,0,0,0,.778.7H37.222A.742.742,0,0,0,38,5.7.742.742,0,0,0,37.222,5Z",
    transform: "translate(-12.263 -1.499)",
    fill: "#0060a6",
    stroke: "#0060a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M17,11.7a.659.659,0,0,0,.609.7H30.391a.707.707,0,0,0,0-1.4H17.609A.659.659,0,0,0,17,11.7Z",
    transform: "translate(-5.1 -3.999)",
    fill: "#0060a6",
    stroke: "#0060a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M17.609,17.4H30.391a.707.707,0,0,0,0-1.4H17.609a.707.707,0,0,0,0,1.4Z",
    transform: "translate(-5.1 -5.499)",
    fill: "#0060a6",
    stroke: "#0060a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M17.609,22.4H30.391a.707.707,0,0,0,0-1.4H17.609a.707.707,0,0,0,0,1.4Z",
    transform: "translate(-5.1 -6.999)",
    fill: "#0060a6",
    stroke: "#0060a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M37.6,26.7a.7.7,0,0,0-.7-.7H32.7a.7.7,0,1,0,0,1.4h4.2A.7.7,0,0,0,37.6,26.7Z",
    transform: "translate(-11.7 -8.5)",
    fill: "#0060a6",
    stroke: "#0060a6",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiet);
export default __webpack_public_path__ + "static/media/icon_diet.d91c6ec8ca5ac978c7483a0cd25c5634.svg";
export { ForwardRef as ReactComponent };